<template>
  <div class="newscenter">
		<div class="contentTop">
			<banner></banner>
			<!-- <product></product> -->
			
			<div class="contentMiddle">
				<headerview></headerview>
				
				<div class="con_all">
					<div class="con_all_one">
						<tipsign :titleName="typeVal"></tipsign>
						<span>当前位置：{{typeVal}}>{{typeVal}}详情</span>
					</div>	
					<div class="con_all_two" 
					     v-show="typesign == 0 || typesign == 1 || typesign == 5 || typesign == 6 || typesign == 9">
						<div class="noticeDetailstitle">{{informData.title || ''}}</div>
						<div class="subtitle">
							  <!-- <span>作者：{{informData.auditor_dictText || ''}}</span> -->
							  <span>作者：{{informData.createBy_dictText || ''}}</span>
							  <span>发布时间：{{informData.pubTime || ''}}</span>
							  <span>浏览次数：{{informData.viewCount || '0'}}</span>
						</div>
						<div v-html="informData.hypertext" class="msg"></div>
					</div>
					
					<div class="con_all_two" v-show="typesign == 2">
						<div class="noticeDetailstitle">{{informData.compilationTitle || ''}}</div>
						<div class="subtitle">
							  <span>作者：{{informData.createBy_dictText || ''}}</span>
							  <span>发布时间：{{informData.createTime || ''}}</span>
							  <span>浏览次数：{{informData.viewCount || '0'}}</span>
						</div>
						<div v-html="informData.compilationContent" class="msg"></div>
					</div>
					
					<div class="con_all_two" v-show="typesign == 3">
						<div class="noticeDetailstitle">{{informData.title || ''}}</div>
						<div class="subtitle">
							  <span>作者：{{informData.createBy_dictText || ''}}</span>
							  <span>发布时间：{{informData.createTime || ''}}</span>
							  <!-- <span>浏览次数：{{informData.viewCount || '0'}}</span> -->
						</div>
						<div v-html="informData.hypertext" class="msg"></div>
					</div>
									
					<div class="con_all_two" v-show="typesign == 4">
						<div class="noticeDetailstitle">{{informData.title || ''}}</div>
						<div class="subtitle">
							  <span>作者：{{informData.author_dictText || ''}}</span>
							  <span>发布时间：{{informData.createTime || ''}}</span>
							  <!-- <span>浏览次数：{{informData.viewCount || '0'}}</span> -->
						</div>
						<!-- <div class="msg">
							{{informData.content}}
						</div> -->
						<div v-html="informData.content" class="msg"></div>
					</div>	
									
					<div class="con_all_two" v-show="typesign == 7">
						<div class="noticeDetailstitle">{{informData.titile || ''}}</div>
						<div class="subtitle">
							  <span>作者：{{informData.createBy_dictText || ''}}</span>
							  <span>发布时间：{{informData.startTime || ''}}</span>
							  <!-- <span>浏览次数：{{informData.viewCount || '0'}}</span> -->
						</div>
						<div v-html="informData.msgContent" class="msg"></div>
					</div>	
								
					<div class="con_all_two" v-show="typesign == 8">
						<div class="noticeDetailstitle">{{informData.titile || ''}}</div>
						<div class="subtitle">
							  <span>姓名：{{informData.name}}</span>
							  <span>年龄：{{informData.age}}</span>
							  <span>职务：{{informData.post}}</span>
						</div>
						<div style="height:3rem;display: flex;justify-content:center;">
							<img :src="$imgUrl + informData.avatar_dictText" style="width:1.4rem;height:2.1rem;" alt=""/> 
						</div>
						<div v-html="informData.awards" class="msg"></div>
					</div>
								
					<div class="con_all_two" v-show="typesign == 10">
						<div class="noticeDetailstitle">{{informData.compilationTitle || ''}}</div>
						<div class="subtitle">
							  <span>作者：{{informData.createBy_dictText || ''}}</span>
							  <span>发布时间：{{informData.publishTime || ''}}</span>
							  <span>浏览次数：{{informData.viewCount || '0'}}</span>
						</div>
						<div v-html="informData.compilationContent" class="msg"></div>
					</div>
					
					<div class="con_all_two" v-show="typesign == 12">
						<div class="noticeDetailstitle">{{informData.title || ''}}</div>
						<div class="subtitle">
							  <span>作者：{{informData.createBy_dictText || ''}}</span>
							  <span>发布时间：{{informData.pubTime || ''}}</span>
							  <span>浏览次数：{{informData.viewCount || '0'}}</span>
						</div>
						<div v-html="informData.introduction" class="msg"></div>
					</div>						
					
					<div class="con_all_three">						
						<span>点赞:</span>
						<img style="margin-right: 1rem;" src="../../../static/index/thumbs_up_cur@2x.png"
						     alt="" v-if="ifThumbsup" @click="thumbsDown()"/>
						<img style="margin-right: 1rem;" src="../../../static/index/thumbs_up@2x.png"
							  alt="" v-if="!ifThumbsup" @click="thumbsup"/>
						<span>转发:</span>
						<img src="../../../static/index/micro_blog@2x.png" alt="" @click="share('sina')"/>
						<!-- <img src="../../../static/index/weChat@2x.png" alt="" @click="share('weixin')"/> -->
						<img src="../../../static/index/qq@2x.png" alt="" @click="share('qzone')"/>
					</div>
					
				</div>
					
			</div>	
						
		<footview></footview>

  </div>
  
 </div> 
</template>

<script>

import tipsign from "../../../components/tipsign/tipsign.vue";
export default {
  components: {
	tipsign,

  },
  
  data() {
		return {
			id:0,
			typesign:0,
			flag:1,
			
			typeVal:"",
			msgContent:"<p>gjoidsgjjifjsgi规划撒谎公安搜嘎视频</p>",
			informData:{},
			ifThumbsup:false,
		};
  },
  
  mounted() {
	    this.$onScrollT()
		
		console.log(this.$route.query.type)
		this.id = this.$route.query.id
		this.typesign = this.$route.query.type
		this.getDetail(this.typesign)
		this.ifthumbsup();	
  },
  
  methods: {
	  
	  //是否点赞
	  ifthumbsup(){
		  var type = this.getType();
		  this.$get(`web/encourage/check?businessId=${this.id}&type=${type}`).then(res=>{
		  	  if(res.success){
		  			console.log(res)	
		  			this.ifThumbsup = res.result				
		  	  }
		  })
	  },
	   thumbsDown(){//取消点赞
	    var type = this.getType();	
		let param = {
				businessId: this.id,
				type: type,
		  };		  		  
		  this.$get(`web/encourage/cancel`,param).then(res=>{
			  if(res.success){
					// console.log(res)
					 this.$message({
						  message: '取消点赞成功',
						  type: 'Warning'
					 });
					 this.ifThumbsup = false;
			  }
		  })  
	  },
	  //点赞
	  thumbsup(){
		  var type = this.getType();	
		  let param = {
				businessId: this.id,
				type: type,
		  };		  		  
		  this.$post(`web/encourage/add`,param).then(res=>{
			  if(res.success){
					// console.log(res)
					 this.$message({
						  message: '点赞成功',
						  type: 'success'
					 });
					 this.ifThumbsup = true;
			  }
		  })
		 
	  },
	  
	  getType(){
		  var type = 0;
		  if(this.typesign == 0){
		  			  type = 2;
		  }else if(this.typesign == 1){
		  			  type = 5;
		  }else if(this.typesign == 2){
		  			  type = 6;
		  }else if(this.typesign == 3){
		  			  type = 4;
		  }else if(this.typesign == 4){
		  			  type = 8;
		  }else if(this.typesign == 5){
		  			  type = 7;
		  }else if(this.typesign == 6){
		  			  this.flag = this.$route.query.flag;
		  			  if(this.flag == 1){
		  				  type = 12;
		  			  }else if(this.flag == 2){
		  				  type = 11;
		  			  }else if(this.flag == 3){
		  				  type = 10;
		  			  }else if(this.flag == 4){
		  				  type = 9;
		  			  }
		  }else if(this.typesign == 7){
		  			  type = 3;
		  }else if(this.typesign == 8){
		  			  type = 16;
		  }else if(this.typesign == 9){
		  			  type = 13;
		  }else if(this.typesign == 10){
		  			  type = 14;
		  }else if(this.typesign == 11){
		  			  type = 15;
		  }else if(this.typesign == 12){
		  			  type = 1;
		  }
		  
		  return type;
	  },
	  
	  share(type){
 
	  	//qq空间分享接口
	  	if(type == 'qzone'){							
			window.open('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url='
	  		+document.location.href+'?sharesource=qzone&title=少先队&pics=图片地址&summary=描述')
	  	}
	  	//新浪微博接口的传参
	  	if(type=='sina'){
	  		window.open('http://service.weibo.com/share/share.php?url='
	  		+document.location.href+'?sharesource=weibo&title=少先队&pic=图片&appkey=微博平台申请的key');				
			
	  	}
	  	
	  	if(type=='weixin'){
	  		 var url = window.location.href,
				encodePath = encodeURIComponent(url),
				targetUrl = 'http://qr.liantu.com/api.php?text=' + encodePath;
			  window.open(targetUrl, 'weixin', 'height=320, width=320');
	  	}
	  	
	  },
	  
	  getDetail(type){
	  		if(type == 0){
	  			this.typeVal='头条新闻';
	  			this.getHeadlinesDetail();
	  		}else if(type == 1){
	  			this.typeVal='校园情报站';
	  			this.getHeadlinesDetail();
	  		}else if(type == 2){
	  			this.typeVal='汇编文章';
	  			this.getNoticeDetail();
	  		}else if(type == 3){
	  			this.typeVal='专题活动';
	  			this.getSpecialDetail();
	  		}else if(type == 4){
				this.typeVal='优秀作品播';
				this.getYpWorksDetail();
			}else if(type == 5){
				this.typeVal='信息报送排行榜';
				this.getHeadlinesDetail();
			}else if(type == 6){
				this.typeVal='光荣榜';
				this.getHeadlinesDetail();
			}else if(type == 7){
				this.typeVal='通知公告';	
				this.getAnnountCementDetail();
			}else if(type == 8){
				this.typeVal='红领巾小记者风采';
				this.getRedScarfDetail();
			}else if(type == 9){
				this.typeVal='社会情报站';
				this.getHeadlinesDetail();
			}else if(type == 10){
				this.typeVal='知识汇编';
				this.getKnowledgeDetail();
			}else if(type == 11){
				this.typeVal='少年队网络视频';
				// this.getYouthteamDetail()
			}else if(type == 12){
				this.typeVal='文化产品';
				this.getCulturalDetail()
			}
	  },
	  
	  //头条新闻（或者校园情报站）（或者信息报送排行榜）（或者光荣榜）(社会情报站)
	  getHeadlinesDetail(){
	  		this.$get(`web/info/queryById?id=${this.id}`).then(res=>{
	  			  if(res.success){
						console.log(res)	
						this.informData = res.result				
	  			  }
	  		})
	  },
	  
	  //公告通知
	  getAnnountCementDetail(){
	  		this.$get(`web/annountCement/queryById?id=${this.id}`).then(res=>{
	  			  if(res.success){
	  						console.log(res)	
	  						this.informData = res.result				
	  			  }
	  		})
	  },
	  
	  //汇编文章
	  getNoticeDetail(){
	  		  this.$get(`web/compilation/ypCompilation/queryById?id=${this.id}`).then(res=>{
	  		  	  if(res.success){
	  		  			console.log(res)	
	  		  			this.informData = res.result				
	  		  	  }
	  		  })
	  },
	   
	  //专题活动
	  getSpecialDetail(){
	  		  this.$get(`web/informationsubmission/ypInformationSubmission/queryById?id=${this.id}`).then(res=>{
	  		  	  if(res.success){
	  		  			console.log(res)	
	  		  			this.informData = res.result				
	  		  	  }
	  		  })
	  },
	  
	  //优秀作品播
	  getYpWorksDetail(){
	  		  this.$get(`web/works/ypWorks/queryById?id=${this.id}`).then(res=>{
	  		  	  if(res.success){
	  		  			console.log(res)	
	  		  			this.informData = res.result				
	  		  	  }
	  		  })
	  },
	  
	  //红领巾小记者风采
	  getRedScarfDetail(){
	  		  this.$get(`web/youngpioneers/ypYoungPioneers/queryById?id=${this.id}`).then(res=>{
	  		  	  if(res.success){
	  		  			console.log(res)	
	  		  			this.informData = res.result				
	  		  	  }
	  		  })
	  },
	  
	  //知识汇编
	  getKnowledgeDetail(){
	  		  this.$get(`web/knowledgeCompilation/queryById?id=${this.id}`).then(res=>{
	  		  	  if(res.success){
	  		  			console.log(res)	
	  		  			this.informData = res.result				
	  		  	  }
	  		  })
	  },
	  
	  //少年队网络视频
	  getYouthteamDetail(){
			  this.$get(`web/teaching/queryById?id=${this.id}`).then(res=>{
				  if(res.success){
						console.log(res)	
						this.informData = res.result				
				  }
			  })
	  },
	  
	  //文化产品
	  getCulturalDetail(){
	  		  this.$get(`web/culturalproduct/queryById?id=${this.id}`).then(res=>{
	  		  	  if(res.success){
	  		  			console.log(res)	
	  		  			this.informData = res.result				
	  		  	  }
	  		  })
	  },
		  
	  
  }
};
</script>

<style scoped lang="scss">
	.newscenter{
		.contentTop{
			// background-image: linear-gradient(#FFFFFF, #E98257);
		}
		
		.contentMiddle{
			padding-top: 1.7rem;
			height: 12.2rem;
			// border: 1px solid #FFFFFF;
			
			.con_all{
				height: 10rem;	
				margin: 0.1rem auto;
				// margin-left: 4rem;
				// margin-right: 4rem;
				width: 12.15rem;
				background: #FFFFFF;
				// overflow-y: auto;
				.con_all_one{
					height: 0.4rem;
					line-height: 0.4rem;
					padding-left: 0.2rem;
					border-bottom: 0.01rem solid #ededed;
					display: flex;
					justify-content: space-between;
					span{
						font-size: 0.14rem;
						margin-right: 0.2rem;
					}
				}
				.con_all_two{
					height: 8.8rem;	
					width: 100%;
					overflow-y: auto;
					.noticeDetailstitle {
						  margin-top: 0.17rem;
						  font-size: 0.28rem;
						  font-family: Microsoft YaHei;
						  font-weight: 400;
						  color: #333333;
						  text-align: center;
					}
					.subtitle {
						  text-align: center;
						  margin-top: 0.21rem;
						  font-size: 0.14rem;
						  font-family: Microsoft YaHei;
						  font-weight: 400;
						  color: #666666;
						  span {
							display: inline-block;
							margin-right: 0.4rem;
							margin-bottom: 0.45rem;
						  }
					}
					.msg {
						  // width: 12rem;
						  margin: 0 auto;
						  margin-left: 0.6rem;
						  margin-right: 0.6rem;
					}
				}
				.con_all_two::-webkit-scrollbar {
				    display: none;
				}
				
				.con_all_three{
					margin-top: 0.2rem;
					margin-right: 0.4rem;
					text-align: right;
					font-size: 0.18rem;
					font-weight: 400;
					height: 0.6rem;
					line-height: 0.6rem;
					img{
						height: 0.33rem;
						width: 0.33rem;
						margin-left: 0.2rem;
					}
				}
				
			}
				
		}	
		
		
	}
	
</style>

<style scoped>
/deep/ .msg img{
	max-width: 100%;
	vertical-align: middle
}
</style>